import React from "react";
import { CircularProgress, Stack } from "@mui/material";

import Item from "./Item";
import Loader from "../../../../components/Loader";
import OpenCardDetail from "../../../board/components/Kanban/openCardDetail";
import TabsController from "./TabsController";
import ByBoardTab from "./ByBoardTab";
import ByTaskTab from "./ByTaskTab";
import { useWorklogHistoryState } from "../../hooks/useWorklogHistoryState";

function History() {
  const { currentTab, loading, setCurrentTab, totalWorklogs, worklogs } =
    useWorklogHistoryState();

  return (
    <>
      <TabsController
        value={currentTab}
        onChange={(event, value) => setCurrentTab(value)}
      />
      <div className="worklog-scroll">
        {!loading && currentTab === "users" ? (
          worklogs?.map((worklog, idx) => (
            <Item worklog={worklog} key={`users-worklog-${idx}`} />
          ))
        ) : currentTab === "by-board" ? (
          <ByBoardTab worklogs={totalWorklogs} />
        ) : currentTab === "by-task" ? (
          <ByTaskTab worklogs={worklogs} />
        ) : (
          <Stack className="width-100 height-100 justify-content-center align-items-center">
            <CircularProgress />
          </Stack>
        )}

        {worklogs.length === 0 && !loading && (
          <>
            <p className="loader-center">Worklog Not Found</p>
          </>
        )}

        {loading && (
          <div className="loader-center">
            <Loader color={"black"} />
          </div>
        )}
        <OpenCardDetail />
      </div>
    </>
  );
}

export default History;
